import React, { useEffect, useState } from 'react';
import {
  bottomBlueIcon,
  bottomRightIcon,
  greenIcon,
  greenLeftIcon,
  midIcon,
  topIcon,
  whiteCircle,
} from '../assets/svg/earlyBirdAssets';
import Container from '../components/Container';
import Literal, { getLocalizedContent } from '../literals/Literal';
import { linkRedeemedContent } from '../data/linkRedeemedContent';

// State icons (inline so the mockup has no new asset dependencies).
const stateIcon = {
  success: (
    <svg viewBox="0 0 24 24" fill="none" className="w-16 h-16 text-green" stroke="currentColor" strokeWidth="1.5">
      <circle cx="12" cy="12" r="10" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 12.5l2.5 2.5L16 9.5" />
    </svg>
  ),
  info: (
    <svg viewBox="0 0 24 24" fill="none" className="w-16 h-16 text-white" stroke="currentColor" strokeWidth="1.5">
      <circle cx="12" cy="12" r="10" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 11v5M12 8h.01" />
    </svg>
  ),
  error: (
    <svg viewBox="0 0 24 24" fill="none" className="w-16 h-16 text-white" stroke="currentColor" strokeWidth="1.5">
      <circle cx="12" cy="12" r="10" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 9l-6 6M9 9l6 6" />
    </svg>
  ),
};

const VALID_STATUSES = ['redeemed', 'already_redeemed', 'error'];

const LinkRedeemed = () => {
  const [status, setStatus] = useState('error');

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const next = params.get('status');
      if (next && VALID_STATUSES.includes(next)) {
        setStatus(next);
      }
    } catch (e) {
      console.log('E', e);
    }
  }, []);

  const state = linkRedeemedContent[status] || linkRedeemedContent.error;

  return (
    <Container className="text-white relative" backgroundImage={false}>
      <div className="flex flex-col gap-y-6 w-full md:text-center md:max-w-3xl md:mt-12">
        <span className="font-americaBold text-2xl leading-none mb-6 text-left md:absolute md:top-20 md:left-20">AT</span>

        <div className="flex flex-col items-center gap-y-8 md:mt-24">
          <div className="md:mx-auto">{stateIcon[state.variant]}</div>

          <h2 className="font-americaBold text-36px leading-none md:w-4/5 md:mx-auto">
            {getLocalizedContent(state.title)}
          </h2>

          <p className="font-americaLight text-lg md:max-w-xl md:mx-auto">
            {getLocalizedContent(state.description)}
          </p>
        </div>

        <div className="h-1px w-full bg-gray my-8" />

        <div className="flex flex-col w-full gap-y-6 text-left md:items-center md:text-center">
          <div>
            <h4 className="font-americaMedium text-md">{Literal('DICE_DOUBTS')}</h4>
            <p className="font-americaLight text-base">{Literal('DICE_HELP')}</p>
          </div>
          <a
            href="https://www.accessticket.app/intercom_v2.html"
            rel="noreferrer"
            target="_blank"
            className="text-sm py-2.5 px-16 text-center md:block font-bold rounded-xl bg-lime text-black w-max cursor-pointer md:mx-auto"
          >
            {Literal('DICE_CONTACT')}
          </a>
        </div>
      </div>

      <div className="absolute top-6 right-0 md:right-72 md:-top-6 transform md:-rotate-90 w-16">{topIcon}</div>
      <div className="absolute bottom-10 right-0 w-10 md:hidden">{midIcon}</div>
      <div className="absolute bottom-0 left-24 w-14">{bottomBlueIcon}</div>
      <div className="absolute bottom-20 right-0 w-10 hidden md:block">{bottomRightIcon}</div>
      <div className="absolute bottom-96 right-0 w-14 hidden md:block">{greenIcon}</div>
      <div className="absolute top-0 left-96 w-20 hidden md:block">{whiteCircle}</div>
      <div className="absolute bottom-72 left-0 w-5 hidden md:block">{greenLeftIcon}</div>
    </Container>
  );
};

export default LinkRedeemed;
